// API Debugging Utility
export const apiDebug = {
  // Log API request
  request: (endpoint: string, method: string, data?: any, headers?: any) => {
    console.group(`🌐 API REQUEST: ${method} ${endpoint}`);
    console.log('📤 Method:', method);
    console.log('🔗 Endpoint:', endpoint);
    if (data) console.log('📦 Request Data:', data);
    if (headers) console.log('📋 Headers:', headers);
    console.groupEnd();
  },

  // Log API response
  response: (endpoint: string, status: number, data: any, expectedFormat?: any) => {
    console.group(`📥 API RESPONSE: ${endpoint} (${status})`);
    console.log('📊 Status:', status);
    console.log('📦 Response Data:', data);
    if (expectedFormat) {
      console.log('🎯 Expected Format:', expectedFormat);
      console.log('✅ Format Match:', checkFormatMatch(data, expectedFormat));
    }
    console.groupEnd();
  },

  // Log API error
  error: (endpoint: string, error: any) => {
    console.group(`❌ API ERROR: ${endpoint}`);
    console.error('💥 Error:', error);
    console.error('📋 Error Type:', typeof error);
    console.error('🔍 Error Details:', {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
      stack: error?.stack
    });
    console.groupEnd();
  },

  // Log authentication state
  auth: (action: string, data?: any) => {
    console.group(`🔐 AUTH: ${action}`);
    console.log('📋 Action:', action);
    if (data) console.log('📦 Data:', data);
    console.log('💾 Local Storage Tokens:', {
      access_token: localStorage.getItem('access_token') ? '✅ Present' : '❌ Missing',
      refresh_token: localStorage.getItem('refresh_token') ? '✅ Present' : '❌ Missing'
    });
    console.groupEnd();
  },

  // Log routing/navigation
  routing: (action: string, data?: any) => {
    console.group(`🧭 ROUTING: ${action}`);
    console.log('📋 Action:', action);
    if (data) console.log('📦 Data:', data);
    console.log('📍 Current URL:', window.location.href);
    console.log('🔗 Current Path:', window.location.pathname);
    console.groupEnd();
  },

  // Log React Query state
  query: (action: string, data?: any) => {
    console.group(`🔄 REACT QUERY: ${action}`);
    console.log('📋 Action:', action);
    if (data) console.log('📦 Data:', data);
    console.groupEnd();
  }
};

// Helper function to check if response matches expected format
function checkFormatMatch(actual: any, expected: any): boolean {
  if (typeof actual !== typeof expected) return false;
  if (typeof actual === 'object') {
    for (const key in expected) {
      if (!(key in actual)) return false;
      if (typeof expected[key] === 'object' && expected[key] !== null) {
        if (!checkFormatMatch(actual[key], expected[key])) return false;
      }
    }
  }
  return true;
}

// Expected API response formats
export const expectedFormats = {
  login: {
    access_token: 'string',
    refresh_token: 'string',
    token_type: 'string',
    expires_in: 'number',
    refresh_expires_in: 'number'
  },
  user: {
    id: 'string',
    email: 'string',
    role: 'string',
    org_id: 'string',
    manager_id: 'string|null',
    is_active: 'boolean',
    created_at: 'string',
    updated_at: 'string'
  }
};
